import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {SharedModule} from '@app/shared/shared.module';
import {ViewRoutingModule} from '@app/views/views.routing';
import {HeadroomModule} from '@ctrl/ngx-headroom';
import {ScrollToModule} from '@nicky-lenaers/ngx-scroll-to';
import {TabsModule} from 'ngx-bootstrap/tabs';
import {ComponentsCarouselModule} from 'src/app/components/carousel/components.carousel.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ViewRoutingModule,
    SharedModule,
    ComponentsCarouselModule,
    TabsModule.forRoot(),
    HeadroomModule,
    ScrollToModule.forRoot()
  ]
})
export class ViewsModule {
}
